import script from "./employee-list-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-list-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-list-modal.vue?vue&type=style&index=0&id=2849f836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2849f836"]])

export default __exports__